import React, {useState} from 'react';
import classnames from 'classnames';

import './style.scss';

import {Icon} from '@atoms/Media/Icon';

interface Props {
    id: string;
    title: string;
    children: React.ReactNode;
    notFolded?: boolean;
}

export const ContentFold: React.FunctionComponent<Props> = ({id, children, title, notFolded}) => {
    const [folded, setFolded] = useState<boolean>(notFolded ? false : true);

    const contentClasses = classnames('content-fold__content', {
        'content-fold__content--open': !folded
    });
    const handleFolded = () => {
        setFolded(!folded);
    };

    return (
        <div className="content-fold">
            <div
                className="content-fold__title"
                onClick={handleFolded}
                onKeyPress={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') handleFolded();
                }}
                aria-expanded={!folded}
                arai-controls={id}
                role='button'
                tabIndex={0}
            >
                <span>{title}</span>
                <Icon name="chevron" up={!folded} />
            </div>
            <div
                className={contentClasses}
                id={id}
                aria-hidden={folded}
            >
                {!folded && children}
            </div>
        </div>
    );
};
